<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px" scrollable>
      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text subheading'>{{ 'TITLE_CHOOSE_YEAR' | translate}}</v-card-title>
        </v-card>
        <v-card-text class="textleft">
          <v-layout wrap>
            <v-flex class="mt-4">
              <v-btn v-for="(yearItem, i) in years"
                     :key="i" color="#004884" dark class="text-none my-4" @click.native="doItem(yearItem)" block large>
                {{yearItem.text}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="#004884" small outline dark class="text-none mb-4" @click.native="cancelItem">{{ 'BUTT_CANCEL' | translate}}</v-btn>
         <!-- <v-btn color="#004884" small dark class="text-none" @click.native="doItem">{{ 'BUTT_OK' | translate}}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DialogChosseYear',
  components: {},
  methods: {
    open: function (item) {
      this.dialog = true
      this.item = item

      this.years = [
        {
          text: Vue.i18n.translate('BTN_ACTUAL_YEAR'),
          year: 0
        }
      ]

      var ownYear = new Date().getFullYear()
      for (var i=0; i < 5; i++) {
        this.years.push( {
          text: '' + (ownYear - i),
          year: ownYear - i
        })
      }
    },
    cancelItem: function () {
      this.dialog = false
      this.$emit('cancelItem', this.item)
    },
    doItem: function (yearItem) {
      this.dialog = false
      this.$emit('doItem', yearItem)
    }
  },
  data () {
    return {
      dialog: false,
      years: [],
      maskName: '',
      item: {},
      Searchmaskname: Vue.i18n.translate('LABEL_PEERGROUPNAME')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/module/dialogs/DialogChooseYear.vue